(() => {
  if (window.__PutaoyaoNavigationV1) return;
  window.__PutaoyaoNavigationV1 = true;

  const itemFor = (node) => node && node.closest('.py-nav__item');

  const closeItem = (item) => {
    if (!item) return;
    item.classList.remove('is-open');
    const toggle = item.querySelector(':scope > .py-nav__parent [data-py-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  };

  const closeAll = (except = null) => {
    document.querySelectorAll('.py-nav__item.is-open').forEach((item) => {
      if (item !== except) closeItem(item);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target instanceof Element ? event.target.closest('[data-py-nav-toggle]') : null;
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const item = itemFor(toggle);
      const willOpen = !item?.classList.contains('is-open');
      closeAll(item);
      if (item) item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    if (!(event.target instanceof Element) || !event.target.closest('.py-nav__item')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openItem = document.querySelector('.py-nav__item.is-open');
    if (!openItem) return;
    const toggle = openItem.querySelector('[data-py-nav-toggle]');
    closeAll();
    toggle?.focus();
  });

  document.addEventListener('focusin', (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('.py-nav__item');
    if (item) closeAll(item);
  });
})();
